import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=a356f106&scoped=true&"
import script from "./ApprovalList.vue?vue&type=script&lang=js&"
export * from "./ApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalList.vue?vue&type=style&index=0&id=a356f106&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a356f106",
  null
  
)

export default component.exports